var CS_ScavengerHunt = {
	
	user_id : 0 ,

	init : function( user_id ){
		
		this.user_id = user_id;

	},

	track_page_view : function(location_id){

		var track_key = 'scavenger_hunt_pageview_' + location_id + '_' + this.user_id;

		if( localStorage.getItem( track_key ) !== null ) return false;

		this.dotrack( track_key , {
        	location 	: location_id,
        });
		
	},

	track_poll_submit : function(poll_id){

		var track_key = 'scavenger_hunt_poll_' + poll_id + '_' + this.user_id;

		if( localStorage.getItem( track_key ) !== null ) return false;

		this.dotrack( track_key , {
        	poll_id 	: poll_id,
        });
		
	},

	track_sponsor_click : function(sponsor_id){

		var track_key = 'scavenger_hunt_sponsor_' + sponsor_id + '_' + this.user_id;

		if( localStorage.getItem( track_key ) !== null ) return false;

		this.dotrack( track_key , {
        	sponsor_id 	: sponsor_id,
        });
		
	},

	track_panorama_node_hit : function(panorama_id , nodeid){

		var track_key = 'scavenger_hunt_panorama_' + panorama_id + '_' + nodeid + '_' + this.user_id;

		if( localStorage.getItem( track_key ) !== null ) return false;

		this.dotrack( track_key , {
        	panorama_id 	: panorama_id,
        	nodeid			: nodeid
        });
		
	},

	dotrack : function(track_key , $data){
		
		$.ajax({
	        url     : '/scavenger-hunt/track',
	        data    : $data,
	        headers:{
            	'X-CSRF-TOKEN':$('meta[name="csrf-token"]').attr('content')
        	},
	        method  : 'POST',
	        success: function (data) {
				
				localStorage.setItem(track_key , true );

				if(data.points){
					$('.scavenger-hunt-points').text(data.points);
				}
	        },
        	
        	error: function (response) {
	           
	        }
	    });
	}

};